import type { Ref } from 'react';
import { Icon } from '../ui/Icon';
import { Button, Card } from '../ui/primitives';
import { cx } from '../ui/primitives/cx';
import { REPORT_QUESTIONS, type ReportId } from '../../utils/reportsView';
import { ReportsHeader, ReportsTile } from './ReportsParts';

export const DETAIL_ID = 'reports-detail';

/**
 * Rediseño · Bloque F → P-084 — la pantalla «Reportes» de P-030: «Elige una pregunta y te respondo con tus
 * números.» y las siete preguntas, en su orden. Desde P-084 las siete son botones que abren su reporte: las tarjetas
 * «Concepto» (B0-05) dejaron de existir porque R3–R7 ya responden con datos reales.
 *
 * Debajo sigue «Ver detalle», la vista analítica de antes, intacta (FUTURE_UPGRADES #38): no es de P-030, y sigue
 * siendo la única que responde por canal y con tablas.
 */
export function ReportsLanding({ onOpen, detailOpen, onToggleDetail, titleRef }: {
  onOpen: (id: ReportId) => void;
  detailOpen: boolean;
  onToggleDetail: () => void;
  titleRef: Ref<HTMLHeadingElement>;
}) {
  return (
    <section aria-labelledby="reports-title" className="n3-reports__screen">
      <ReportsHeader lead="Elige una pregunta y te respondo con tus números." title="Reportes" titleRef={titleRef} />

      <ul aria-label="Preguntas" className="n3-reports__questions">
        {REPORT_QUESTIONS.map((question) => (
          <li className={cx('n3-reports__question', question.key === 'r1' && 'n3-reports__question--featured')} key={question.key}>
            <button className="n3-reports__question-button" onClick={() => onOpen(question.report)} type="button">
              <ReportsTile icon={question.icon} tone={question.tone} />
              <span className="n3-reports__question-body">
                <span className="n3-reports__question-title"><span>{question.title}</span></span>
                <span className="n3-reports__question-text">{question.description}</span>
              </span>
              <span aria-hidden="true" className="n3-reports__question-go"><Icon name="chevron-right" size={16} /></span>
            </button>
          </li>
        ))}
      </ul>

      <Card aria-labelledby="reports-detail-title" as="section" className="n3-reports__detail">
        <div className="n3-reports__detail-text">
          <h2 className="n3-reports__detail-title" id="reports-detail-title">Ver detalle</h2>
          <p className="n3-reports__detail-lead">La vista analítica completa: productos, tendencia diaria, cortes e inventario del rango que elijas.</p>
        </div>
        <Button
          aria-controls={DETAIL_ID}
          aria-expanded={detailOpen}
          className="n3-reports__detail-toggle"
          iconEnd={<Icon name={detailOpen ? 'chevron-up' : 'chevron-down'} size={16} />}
          onClick={onToggleDetail}
          variant="secondary"
        >
          {detailOpen ? 'Ocultar detalle' : 'Ver detalle'}
        </Button>
      </Card>
    </section>
  );
}
